/** PT → EN: nomes do catálogo do simulador (ficheiros em images/icons, categorias à parte). */
export default {
    // Armadilhas
    "Armadilha de Escopeta": "Shotgun Trap",
    "Armadilha": "Snap Trap",
    "Local de Sistema Antiaéreo": "SAM Site",
    "Mina Terrestre": "Land Mine",
    "Sentinela Automática": "Auto Turret",
    "Sentinela Lança-Chamas": "Flame Turret",

    // Armas
    "Arpão": "Speargun",
    "Coquetel Molotov": "Molotov Cocktail",
    "Escopeta Cano d'Água": "Waterpipe Shotgun",
    "Escopeta de Cano Duplo": "Double Barrel Shotgun",
    "Escopeta de Repetição": "Pump Shotgun",
    "Escopeta SPAS-12": "Spas-12 Shotgun",
    "Glock": "Prototype 17",
    "Granada de Luz": "Flashbang",
    "Granada F1": "F1 Grenade",
    "Lança-Chamas": "Flame Thrower",
    "Lança-Foguetes": "Rocket Launcher",
    "Lançador de Granadas": "Multiple Grenade Launcher",
    "Lançador de Granadas Múltiplas": "Multiple Grenade Launcher",
    "LR-300": "LR-300 Assault Rifle",
    "M249": "M249",
    "Metralhadora Caseira": "HMLMG",
    "MP5A4": "MP5A4",
    "Pistola M92": "M92 Pistol",
    "Pistola Semiautomática": "Semi-Automatic Pistol",
    "Revólver Python": "Python Revolver",
    "Rifle de Assalto de Gelo": "Ice Assault Rifle",
    "Rifle de Assalto": "Assault Rifle",
    "Rifle de Ferrolho": "Bolt Action Rifle",
    "Rifle L96": "L96 Rifle",
    "Rifle M39": "M39 Rifle",
    "Rifle Semiautomático": "Semi-Automatic Rifle",
    "SMG Personalizada": "Custom SMG",
    "Thompson": "Thompson",

    // Armas — itens de armas (acessórios)
    "Acelerador de Cano": "Muzzle Boost",
    "Carregador Estendido": "Extended Magazine",
    "Freio de Boca": "Muzzle Brake",
    "Lanterna de Arma": "Weapon Flashlight",
    "Mira 8x": "8x Zoom Scope",
    "Mira Holográfica": "Holosight",
    "Mira Laser": "Weapon Lasersight",
    "Mira Telescópica 16x": "16x Zoom Scope",

    // Comida
    "Abóbora": "Pumpkin",
    "Barra de Chocolate": "Chocolate Bar",
    "Barra de Granola": "Granola Bar",
    "Chá de Cura": "Healing Tea",
    "Chá de Madeira": "Wood Tea",
    "Chá de Minério": "Ore Tea",
    "Chá": "Tea",
    "Frango Cozido": "Cooked Chicken",
    "Lata de Atum": "Can of Tuna",
    "Lata de Feijão": "Can of Beans",
    "Milho": "Corn",
    "Mirtilos": "Blueberries",

    // Componentes
    "Chapa de Metal": "Sheet Metal",
    "Corda": "Rope",
    "Corpo de Rifle": "Rifle Body",
    "Corpo de Semiautomática": "Semi Automatic Body",
    "Corpo de SMG": "SMG Body",
    "Engrenagens": "Gears",
    "Fusível Elétrico": "Electric Fuse",
    "Kit de Costura": "Sewing Kit",
    "Lâmina de Metal": "Metal Blade",
    "Lona": "Tarp",
    "Mola de Metal": "Metal Spring",
    "Placas de Trânsito": "Road Signs",
    "Sucata Tecnológica": "Tech Trash",
    "Tanque de Propano Vazio": "Empty Propane Tank",
    "Tubo de Metal": "Metal Pipe",

    // Construção
    "Armário de Ferramentas": "Tool Cupboard",
    "Armário": "Locker",
    "Bancada de Reparo": "Repair Bench",
    "Barricada de Concreto": "Concrete Barricade",
    "Barricada de Madeira": "Wooden Barricade",
    "Barricada de Metal": "Metal Barricade",
    "Barricada de Pedra": "Stone Barricade",
    "Barricada de Sacos de Areia": "Sandbag Barricade",
    "Barril de Água": "Water Barrel",
    "Bomba de Petróleo": "Pump Jack",
    "Caixa de Entrega": "Drop Box",
    "Caixa Grande de Madeira": "Large Wood Box",
    "Caixa Pequena de Madeira": "Wood Storage Box",
    "Cerca de Arame": "Chainlink Fence",
    "Coletor de Água Pequeno": "Small Water Catcher",
    "Coletor Grande de Água": "Large Water Catcher",
    "Controlador de Porta": "Door Controller",
    "Embrasura Horizontal de Metal": "Metal Horizontal Embrasure",
    "Embrasura Vertical de Metal": "Metal Vertical Embrasure",
    "Escada": "Wooden Ladder",
    "Esconderijo Pequeno": "Small Stash",
    "Escotilha de Escada Triangular": "Triangle Ladder Hatch",
    "Escotilha de Escada": "Ladder Hatch",
    "Fechadura Eletrônica": "Code Lock",
    "Fechadura": "Key Lock",
    "Fornalha Grande": "Large Furnace",
    "Fornalha": "Furnace",
    "Geladeira": "Fridge",
    "Grade de Madeira para Janela": "Wooden Window Bars",
    "Grade de Metal para Janela": "Metal Window Bars",
    "Grade de Piso Triangular": "Triangle Floor Grill",
    "Grade de Piso": "Floor Grill",
    "Grades de Janela Reforçadas": "Reinforced Window Bars",
    "Janela de Vidro Reforçado": "Reinforced Glass Window",
    "Máquina de Venda": "Vending Machine",
    "Mesa de Mistura": "Mixing Table",
    "Mesa de Pesquisa": "Research Table",
    "Mesa de Trabalho Nível 1": "Workbench Level 1",
    "Mesa de Trabalho Nível 2": "Workbench Level 2",
    "Mesa de Trabalho Nível 3": "Workbench Level 3",
    "Muro Alto de Madeira": "High External Wooden Wall",
    "Muro Alto de Pedra": "High External Stone Wall",
    "Persiana de Madeira": "Wood Shutters",
    "Planta de Construção": "Building Plan",
    "Porta Blindada": "Armored Door",
    "Porta de Chapa de Metal": "Sheet Metal Door",
    "Porta de Garagem": "Garage Door",
    "Porta de Madeira": "Wooden Door",
    "Porta Dupla Blindada": "Armored Double Door",
    "Porta Dupla de Chapa de Metal": "Sheet Metal Double Door",
    "Porta Dupla de Madeira": "Wood Double Door",
    "Portão Alto de Madeira": "High External Wooden Gate",
    "Portão Alto de Pedra": "High External Stone Gate",
    "Portão de Vedação de Arame": "Chainlink Fence Gate",
    "Purificador de Água": "Water Purifier",
    "Saco de Dormir": "Sleeping Bag",
    "Vitrine de Metal": "Metal Shop Front",
    "Vitrine": "Shop Front",

    // Elétrica
    "Alarme Inteligente": "Smart Alarm",
    "Alarme Sonoro": "Spooky Speaker",
    "Aquecedor Elétrico": "Electric Heater",
    "Aspersor": "Sprinkler",
    "Bateria Grande Recarregável": "Large Rechargeable Battery",
    "Bateria Média Recarregável": "Medium Rechargeable Battery",
    "Bateria Pequena Recarregável": "Small Rechargeable Battery",
    "Bloqueador": "Blocker",
    "Bobina de Tesla": "Tesla Coil",
    "Bomba d'Água": "Water Pump",
    "Botão": "Button",
    "Câmera CCTV PTZ": "PTZ CCTV Camera",
    "Combinador de Fontes": "Root Combiner",
    "Combinador Industrial": "Industrial Combiner",
    "Detector a Laser": "Laser Detector",
    "Divisor Industrial": "Industrial Splitter",
    "Elevador": "Elevator",
    "Estação de Computador": "Computer Station",
    "Fabricador Industrial": "Industrial Crafter",
    "Ferramenta de Fio": "Wire Tool",
    "Fornalha Elétrica": "Electric Furnace",
    "Gerador de Teste": "Test Generator",
    "Gerador Pequeno": "Small Generator",
    "Holofote": "Search Light",
    "Ignitor": "Igniter",
    "Interruptor Inteligente": "Smart Switch",
    "Interruptor": "Switch",
    "Luz de Parede Industrial": "Industrial Wall Light",
    "Luz de Teto": "Ceiling Light",
    "Luz Simples": "Simple Light",
    "Monitor de Armazenamento": "Storage Monitor",
    "Painel Solar Grande": "Large Solar Panel",
    "Purificador d'Água Elétrico": "Powered Water Purifier",
    "Ramificador Elétrico": "Electrical Branch",
    "Separador": "Splitter",
    "Temporizador": "Timer",
    "Transportador Industrial": "Industrial Conveyor",
    "Turbina Eólica": "Wind Turbine",

    // Ferramentas
    "Binóculos": "Binoculars",
    "Britadeira": "Jackhammer",
    "Carga de Demolição": "Satchel Charge",
    "Carga Explosiva com Temporizador": "Timed Explosive Charge",
    "Granada de Fumaça": "Smoke Grenade",
    "Lanterna": "Flashlight",
    "Machado Recondicionado": "Salvaged Axe",
    "Martelo Recondicionado": "Salvaged Hammer",
    "Martelo": "Hammer",
    "Motosserra": "Chainsaw",
    "Picareta de Gelo Recondicionada": "Salvaged Icepick",
    "Sinalizador de Suprimentos": "Supply Signal",

    // Itens
    "Baú Grande de Madeira": "Large Wood Box",
    "Cama": "Bed",
    "Canteiro de Plantas Grande": "Large Planter Box",
    "Canteiro de Plantas Pequeno": "Small Planter Box",
    "Compostor": "Composter",
    "Drone": "Drone",
    "Estação de Trabalho": "Engineering Workbench",
    "Fliperama Chippy": "Chippy Arcade Game",
    "Lanterna Xing-Ling": "Chinese Lantern",
    "Refinaria de Petróleo Pequena": "Small Oil Refinery",

    // Medicamentos
    "Bandagem": "Bandage",
    "Kit Médico Grande": "Large Medkit",
    "Seringa Médica": "Medical Syringe",

    // Munição (o catálogo mostra "5 56" — o ponto do ficheiro vira espaço)
    "Bala de Alta Velocidade de Pistola": "HV Pistol Ammo",
    "Bala de Pistola": "Pistol Bullet",
    "Bala Incendiária de Pistola": "Incendiary Pistol Bullet",
    "Balote Calibre 12": "12 Gauge Slug",
    "Cartucho Artesanal": "Handmade Shell",
    "Chumbo Grosso Calibre 12": "12 Gauge Buckshot",
    "Foguete de Alta Velocidade": "High Velocity Rocket",
    "Foguete de Fumaça": "Smoke Rocket",
    "Foguete Incendiário": "Incendiary Rocket",
    "Foguete LMF": "MLRS Rocket",
    "Foguete": "Rocket",
    "Granada de Fumaça de 40mm": "40mm Smoke Grenade",
    "Granada Explosiva de 40mm": "40mm HE Grenade",
    "Lança para Arpão": "Speargun Spear",
    "Munição 5 56 de Alta Velocidade de Rifle": "HV 5.56 Rifle Ammo",
    "Munição 5 56 de Rifle": "5.56 Rifle Ammo",
    "Munição 5 56 Explosiva de Rifle": "Explosive 5.56 Rifle Ammo",
    "Munição 5 56 Incendiária de Rifle": "Incendiary 5.56 Rifle Ammo",
    "Munição 5.56 de Alta Velocidade de Rifle": "HV 5.56 Rifle Ammo",
    "Munição 5.56 de Rifle": "5.56 Rifle Ammo",
    "Munição 5.56 Explosiva de Rifle": "Explosive 5.56 Rifle Ammo",
    "Munição 5.56 Incendiária de Rifle": "Incendiary 5.56 Rifle Ammo",
    "Munição Antiaérea": "SAM Ammo",
    "Munição de Escopeta de 40mm": "40mm Shotgun Round",
    "Munição Incendiária Calibre 12": "12 Gauge Incendiary Shell",

    // Outros
    "Cartão de Acesso Azul": "Blue Keycard",
    "Cartão de Acesso Verde": "Green Keycard",
    "Cartão de Acesso Vermelho": "Red Keycard",

    // Recursos
    "Câmera CCTV": "CCTV Camera",
    "Carvão Vegetal": "Charcoal",
    "Combustível de Baixa Qualidade": "Low Grade Fuel",
    "Combustível Diesel": "Diesel Fuel",
    "Computador de Mira": "Targeting Computer",
    "Couro": "Leather",
    "Enxofre": "Sulfur",
    "Explosivos": "Explosives",
    "Fragmentos de Metal": "Metal Fragments",
    "Fragmentos de Ossos": "Bone Fragments",
    "Gordura Animal": "Animal Fat",
    "Madeira": "Wood",
    "Metal de Alta Qualidade": "High Quality Metal",
    "Minério de Enxofre": "Sulfur Ore",
    "Minério de Metal de Alta Qualidade": "High Quality Metal Ore",
    "Minério de Metal": "Metal Ore",
    "Pano": "Cloth",
    "Pedra": "Stones",
    "Petróleo Bruto": "Crude Oil",
    "Pólvora": "Gun Powder",
    "Sucata": "Scrap",

    // Roupas
    "Balaclava de Pano": "Balaclava",
    "Balaclava Improvisada": "Improvised Balaclava",
    "Bandana": "Bandana Mask",
    "Blusão": "Hoodie",
    "Botas": "Boots",
    "Calça Blindada": "Heavy Plate Pants",
    "Calça de Couro": "Burlap Trousers",
    "Calça de Madeira": "Wood Armor Pants",
    "Calça": "Pants",
    "Camisa": "Shirt",
    "Camiseta Manga Longa": "Longsleeve T-Shirt",
    "Camiseta": "T-Shirt",
    "Capacete Blindado": "Heavy Plate Helmet",
    "Capacete de Balde": "Bucket Helmet",
    "Capacete de Lata de Café": "Coffee Can Helmet",
    "Capacete de Madeira": "Wood Armor Helmet",
    "Capacete de Manifestação": "Riot Helmet",
    "Casaco de Neve": "Snow Jacket",
    "Chapéu de Minerador": "Miners Hat",
    "Chapéu Militar": "Boonie Hat",
    "Cocar de Lobo": "Wolf Headdress",
    "Colete Blindado": "Heavy Plate Jacket",
    "Colete de Metal": "Metal Chest Plate",
    "Colete de Pele Animal": "Hide Vest",
    "Jaqueta de Placas de Trânsito": "Road Sign Jacket",
    "Jaqueta": "Jacket",
    "Luvas de Couro": "Leather Gloves",
    "Luvas de Sinalização": "Roadsign Gloves",
    "Luvas Táticas": "Tactical Gloves",
    "Máscara de Metal de Gelo": "Ice Metal Facemask",
    "Máscara de Metal": "Metal Facemask",
    "Óculos de Visão Noturna": "Night Vision Goggles",
    "Peitoral de Madeira": "Wood Chestplate",
    "Roupa de Mergulho": "Wetsuit",
    "Saia de Placas de Trânsito": "Road Sign Kilt",
    "Sela de Cavalo Dupla": "Double Horse Saddle",
    "Sela de Cavalo": "Single Horse Saddle",
    "Traje Ártico": "Arctic Suit",
    "Traje de Radiação": "Hazmat Suit",
    "Traje Ninja": "Ninja Suit",
    "Traje Nômade": "Nomad Suit",

    // Veículos (fora do simulador, mas no manifest)
    "Barco a Motor": "Rowboat",
    "Helicóptero de Sucata": "Scrap Transport Helicopter",
    "Minicóptero": "Minicopter",
};
